'use client';

import { ContentWrap, Css, Responsive, themed } from '@/ui';
import styled from '@emotion/styled';
import { getHeadingStyle } from '../../../../styles/utils/getHeadingStyle';
import { theme } from '../../../../styles/theme';

export const Section = styled(ContentWrap.withComponent('section'))`
	padding: ${Css.pxToRemFromTheme(32)} 0;

	ul {
		max-width: ${themed(({ layout }) => layout.main.textMaxWidth)};
	}
`;

export const SectionHeader = styled.h2`
	${getHeadingStyle(theme, 'h4')}
	margin-bottom: ${Css.pxToRemFromTheme(16)};
	max-width: 50%;
	line-height: 80%;
`;

export const ItemSectionTop = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: ${Css.pxToRemFromTheme(24)};
`;

export const ItemSectionTitle = styled.h3`
	${getHeadingStyle(theme, 'h4')}
	line-height: normal;
	margin-bottom: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRemFromTheme(30)};
	}
`;

export const ItemSectionSubtitle = styled.div`
	font-size: ${Css.pxToRemFromTheme(12)};
	text-transform: uppercase;
`;
